import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => {
  return (
    <header>
      <div className="container header-container">
        <div className="logo">
          <img src="/images/logo.png" alt="Containerized Conversations Logo" />
          <h1>Containerized Conversations</h1>
        </div>
        <nav>
          <ul>
            <li><NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink></li>
            <li><NavLink to="/episodes" className={({ isActive }) => isActive ? 'active' : ''}>Episodes</NavLink></li>
            <li><NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>About</NavLink></li>
            <li>
              <div className="dropdown">
                <span className="dropdown-toggle">Mission</span>
                <div className="dropdown-menu">
                  <NavLink to="/jesse-mission" className={({ isActive }) => isActive ? 'active' : ''}>Jesse's Mission</NavLink>
                  <NavLink to="/josh-mission" className={({ isActive }) => isActive ? 'active' : ''}>Josh's Mission</NavLink>
                </div>
              </div>
            </li>
            <li><NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>Contact</NavLink></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;